import styled from "styled-components";
import { MAIN_THEME } from "styles/colors";
import { FONT_FAMILY_BOLD } from "styles/typography";

interface Props {
	title: string;
	description?: string;
}

const Container = styled.div`
	padding: 30px 30px 20px;

	@media (max-width: 1200px) {
		padding: 25px 20px 15px;
	}

	@media (max-width: 768px) {
		padding: 20px 15px 15px;
	}

	@media (max-width: 480px) {
		padding: 15px 10px 10px;
	}
`;

const Title = styled.h1`
	font-size: 32px;
	font-family: ${FONT_FAMILY_BOLD};
	font-weight: 700;
	color: ${MAIN_THEME.TEXT_PRIMARY};
	margin: 0 0 8px 0;
	line-height: 1.2;

	@media (max-width: 1200px) {
		font-size: 28px;
	}

	@media (max-width: 768px) {
		font-size: 24px;
		margin: 0 0 6px 0;
	}

	@media (max-width: 480px) {
		font-size: 22px;
	}
`;

const Description = styled.p`
	font-size: 16px;
	color: ${MAIN_THEME.TEXT_SECONDARY};
	margin: 0;
	line-height: 1.5;
	font-weight: 400;

	@media (max-width: 768px) {
		font-size: 15px;
	}

	@media (max-width: 480px) {
		font-size: 14px;
	}
`;

const PageHeader = (props: Props): JSX.Element => {
	const { title, description } = props;

	return (
		<Container>
			<Title>{title}</Title>
			{description && <Description>{description}</Description>}
		</Container>
	);
};

export default PageHeader;
